import React, { useEffect } from "react";
import {
	Grid,
	Box,
	Button,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import logo from "../tarteeb.png";
import logo2 from "../logo1.png";
import { tableCellClasses } from "@mui/material/TableCell";
import skipcash from "../skipcash.png";

export default function Summary(props) {
	const { exhibitor, booth } = (props.location && props.location.state) || {};

	const convertNumber = (number) => {
		return new Intl.NumberFormat().format(number);
	};

	useEffect(() => {
		if (exhibitor === undefined || booth === undefined) {
			alert("Error!, Please complete the previous process");
			props.history.push("/");
		}
		return () => {
			console.log("changed");
		};
	}, [exhibitor, booth, props.history]);

	const StyledTableCell = styled(TableCell)(({ theme }) => ({
		[`&.${tableCellClasses.head}`]: {
			backgroundColor: "#a67a31",
			color: theme.palette.common.white,
		},
		[`&.${tableCellClasses.body}`]: {
			fontSize: 14,
		},
	}));

	const sendDetails = async () => {
		const data = {
			exhibitor,
			booth,
		};
		console.log("data", data);
		const response = await fetch(
			"https://tarteeb.herokuapp.com/api/reservation/pay",
			// "http://localhost:3001/api/reservation/pay",
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			}
		);
		const json = await response.json();
		// console.log("json", json);
		// window.open(json.payUrl, "_blank").focus();
		window.location = json.payUrl;
	};

	const StyledTableRow = styled(TableRow)(() => ({
		"&:nth-of-type(odd)": {
			backgroundColor: "rgba(166, 122, 49, 0.1)",
		},
		// hide last border
		"&:last-child td, &:last-child th": {
			border: 0,
		},
	}));

	window.addEventListener("popstate", function (event) {
		// The URL changed...
		console.log("event", event);
	});

	return (
		<Box sx={{ minHeight: "100vh", width: "100%", backgroundColor: "#F4F4F5" }}>
			<Grid container direction="column" alignItems="center">
				<Grid container direction="row" style={{ backgroundColor: "white" }}>
					<Grid
						item
						xs={6}
						style={{
							display: "flex",
							alignSelf: "center",
							justifyContent: "flex-end",
							paddingRight: "0.5%",
						}}
					>
						<img
							alt="tarteeb-Logo"
							src={logo}
							style={{ height: 150, width: 200 }}
						/>
					</Grid>
					<Grid
						item
						xs={6}
						style={{
							display: "flex",
							alignSelf: "center",
							justifyContent: "flex-start",
							paddingRight: "0.5%",
						}}
					>
						<img
							alt="rwaiha-Logo"
							src={logo2}
							style={{ height: 120, width: 160 }}
						/>
					</Grid>
				</Grid>

				<Grid
					container
					rowSpacing={1}
					direction="row"
					justifyContent="center"
					columnSpacing={{ xs: 1, sm: 2, md: 3 }}
					style={{
						backgroundColor: "white",
						width: "80%",
						margin: "2%",
						borderRadius: 15,
						paddingBottom: "2%",
						display: "flex",
						justifyContent: "center",
					}}
				>
					<Grid item xs={12}>
						<Grid container direction="row">
							<Grid item xs={6}>
								<h2 style={{ fontFamily: "Poppins", color: "#a67a31" }}>
									Reservation Summary
								</h2>
							</Grid>
							<Grid
								item
								xs={6}
								style={{ display: "flex", justifyContent: "flex-end" }}
							>
								<h2
									style={{
										fontFamily: "Poppins",
										color: "#a67a31",
										marginRight: "7%",
									}}
								>
									ملخص الحجز
								</h2>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={6}>
						<TableContainer style={{ width: "80%" }} component={Paper}>
							<Table aria-label="customized table">
								<TableHead>
									<TableRow>
										<StyledTableCell
											style={{ fontFamily: "Poppins", color: "#fff", flexDirection: "row", }}
										>
											<strong>Business Details</strong>
										</StyledTableCell>
                    <StyledTableCell
											style={{ fontFamily: "Poppins", color: "#fff", flexDirection: "row", }}
										>
											<strong>معلومات الشركة</strong>
										</StyledTableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									<StyledTableRow key="business-name">
										<StyledTableCell
											component="th"
											scope="row"
											style={{ fontFamily: "Poppins", color: "#a67a31" }}
										>
											<strong>Business Name: </strong>{" "}
											{exhibitor && exhibitor.businessName}
										</StyledTableCell>
                    <StyledTableCell
											component="th"
											scope="row"
											style={{ fontFamily: "Poppins", color: "#a67a31" }}
										>
										</StyledTableCell>
									</StyledTableRow>
									<StyledTableRow key="name">
										<StyledTableCell
											style={{ fontFamily: "Poppins", color: "#a67a31" }}
										>
											<strong>Name: </strong> {exhibitor && exhibitor.firstName}{" "}
											{exhibitor && exhibitor.lastName}
										</StyledTableCell>
                    <StyledTableCell
											component="th"
											scope="row"
											style={{ fontFamily: "Poppins", color: "#a67a31" }}
										>
										</StyledTableCell>
									</StyledTableRow>
									<StyledTableRow key="email">
										<StyledTableCell
											style={{ fontFamily: "Poppins", color: "#a67a31" }}
											component="th"
											scope="row"
										>
											<strong>Email: </strong> {exhibitor && exhibitor.email}
										</StyledTableCell>
                    <StyledTableCell
											component="th"
											scope="row"
											style={{ fontFamily: "Poppins", color: "#a67a31" }}
										>
										</StyledTableCell>
									</StyledTableRow>
									<StyledTableRow key="phone-number">
										<StyledTableCell
											style={{ fontFamily: "Poppins", color: "#a67a31" }}
											component="th"
											scope="row"
										>
											<strong>Phone: </strong>{" "}
											{exhibitor && exhibitor.phoneNumber}
										</StyledTableCell>
                    <StyledTableCell
											component="th"
											scope="row"
											style={{ fontFamily: "Poppins", color: "#a67a31" }}
										>
										</StyledTableCell>
									</StyledTableRow>
								</TableBody>
							</Table>
						</TableContainer>
					</Grid>

					<Grid item xs={6}>
						<TableContainer style={{ width: "80%" }} component={Paper}>
							<Table aria-label="customized table">
								<TableHead>
									<TableRow>
										<StyledTableCell
											style={{ fontFamily: "Poppins", color: "#fff" }}
										>
											<strong>Booth Details</strong>
										</StyledTableCell>
                    <StyledTableCell
											style={{ fontFamily: "Poppins", color: "#fff", flexDirection: "row", }}
										>
											<strong>معلومات المساحة</strong>
										</StyledTableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									<StyledTableRow key="booth-category">
										<StyledTableCell
											style={{ fontFamily: "Poppins", color: "#a67a31" }}
											component="th"
											scope="row"
										>
											<strong>Category: </strong> Category{" "}
											{booth && booth.category}
										</StyledTableCell>
                    <StyledTableCell
											component="th"
											scope="row"
											style={{ fontFamily: "Poppins", color: "#a67a31" }}
										>
										</StyledTableCell>
									</StyledTableRow>
									<StyledTableRow key="booth-number">
										<StyledTableCell
											style={{ fontFamily: "Poppins", color: "#a67a31" }}
										>
											<strong>Booth Number: </strong>
											{booth && booth.name}
										</StyledTableCell>
                    <StyledTableCell
											component="th"
											scope="row"
											style={{ fontFamily: "Poppins", color: "#a67a31" }}
										>
										</StyledTableCell>
									</StyledTableRow>
									<StyledTableRow key="booth-price">
										<StyledTableCell
											style={{ fontFamily: "Poppins", color: "#a67a31" }}
											component="th"
											scope="row"
										>
											<strong>Price: </strong>{" "}
											{booth && convertNumber(booth.price)} QAR
										</StyledTableCell>
                    <StyledTableCell
											component="th"
											scope="row"
											style={{ fontFamily: "Poppins", color: "#a67a31" }}
										>
										</StyledTableCell>
									</StyledTableRow>
								</TableBody>
							</Table>
						</TableContainer>
					</Grid>

					<Grid container justifyContent="center" style={{ marginTop: "2%" }}>
						<TableContainer
							style={{ width: "40%", marginTop: "2%" }}
							component={Paper}
						>
							<Table aria-label="customized table">
								<TableBody>
									<StyledTableRow key="total-section">
										<StyledTableCell
											component="th"
											scope="row"
											style={{ width: "100%" }}
										>
											{/* <strong>
                        <span>Total: </span>
                        <span style={{ textAlign: "right" }}>
                          {convertNumber(booth.price)} QAR{" "}
                        </span>
                      </strong> */}
											<Grid container>
												<Grid item xs={4} style={{ textAlign: "left" }}>
													<strong
														style={{ fontFamily: "Poppins", color: "#a67a31" }}
													>
														{" "}
														<span>Total: </span>
													</strong>
												</Grid>

												<Grid item xs={4} style={{ textAlign: "center" }}>
													<strong
														style={{ fontFamily: "Poppins", color: "#a67a31" }}
													>
														<span>
															{booth && convertNumber(booth.price)} QAR{" "}
														</span>
													</strong>
												</Grid>

                        <Grid item xs={4} style={{ textAlign: "right" }}>
													<strong
														style={{ fontFamily: "Poppins", color: "#a67a31" }}
													>
														{" "}
														<span>:المجموع</span>
													</strong>
												</Grid>
											</Grid>
										</StyledTableCell>
									</StyledTableRow>
									<StyledTableRow key="button-row">
										<StyledTableCell>
											<Button
												style={{
													backgroundColor: "#a67a31",
													color: "#fff",
													borderColor: "#a67a31",
													fontFamily: "Poppins",
													width: "100%",
													height: "100%",
												}}
												variant="outlined"
												onClick={() => sendDetails()}
											>
												Proceeed to Payment  |  المتابعة للدفع
											</Button>
										</StyledTableCell>
									</StyledTableRow>
								</TableBody>
							</Table>
						</TableContainer>
					</Grid>
				</Grid>
				<Grid container justifyContent="center">
					<img alt="skipcash" src={skipcash} />
				</Grid>
			</Grid>
		</Box>
	);
}
